import { Card, CardContent, Grid, Stack, Typography } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import { duplicateIcon, groupIcon, infoIcon } from 'common/assets/images';
import ButtonComp from 'common/components/Button/ButtonComp';
import InfoTooltip from 'common/components/Tooltip/Tooltip';
import { rrcpDashboardRoutes } from 'common/constants/rrcp-dashboard-routes';
import { TOOLTIP_TEXT } from 'common/constants/Tooltip';
import { toSentenceCase, urlWithTenant } from 'common/utils/utilFunctions';

import styles from './AIModels.module.scss';

const { aimodels, controlDeDuplication } = rrcpDashboardRoutes;

const { CONTROL_DE_DUPLICATION, CONTROL_QUALITY_GRAMMAR_CHECK } = TOOLTIP_TEXT;

const AIModels = () => {
	const navigate = useNavigate();
	const navigateToControlDedupLandingPage = () => {
		//  navigation of 1st tile
		navigate(urlWithTenant(`/${aimodels}/${controlDeDuplication}`));
	};
	return (
		<Grid container data-testid="ai-models">
			<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
				<Typography className={styles['header-ai']}>AI models</Typography>
			</Grid>
			<Grid container className={styles['grid-main']} spacing={4}>
				<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
					<Card className={styles['card-content']}>
						<CardContent className={styles['card-details']}>
							<Stack direction="row">
								<Typography className={styles['covered-header']}>
									{toSentenceCase('Control De-Duplication')}
								</Typography>
								<InfoTooltip
									className={styles['overview-info']}
									title={CONTROL_DE_DUPLICATION}
								>
									<img
										src={infoIcon}
										alt="info"
										className={styles['overview-info']}
									/>
								</InfoTooltip>
							</Stack>
							<Stack alignItems="center">
								<img
									src={duplicateIcon}
									alt="duplicate"
									className={styles['duplicate-icon']}
								/>
							</Stack>
							<ButtonComp
								btnType="primary"
								clickHandler={navigateToControlDedupLandingPage}
							>
								{toSentenceCase('Click to View')}
							</ButtonComp>
						</CardContent>
					</Card>
				</Grid>
				<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
					<Card className={styles['card-content']}>
						<CardContent className={styles['card-details']}>
							<Stack direction="row">
								<Typography className={styles['covered-header']}>
									Control quality and grammar check
								</Typography>
								<InfoTooltip
									className={styles['overview-info']}
									title={CONTROL_QUALITY_GRAMMAR_CHECK}
								>
									<img
										src={infoIcon}
										alt="info"
										className={styles['overview-info']}
									/>
								</InfoTooltip>
							</Stack>
							<Stack alignItems="center">
								<img
									src={groupIcon}
									alt="group"
									className={styles['duplicate-icon']}
								/>
							</Stack>
							<ButtonComp btnType="primary" clickHandler={() => {}} disabled>
								{toSentenceCase('Click to View')}
							</ButtonComp>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default AIModels;
